const SYSTEM_MAINTENANCE_NOTICE = {
  id: 'system-maintenance-2026-10',
  title: 'System Maintenance',
  highlight: 'response times for calls, texts, chats, and emails may be longer than usual',
  message: "We're upgrading our systems this week, so response times for calls, texts, chats, and emails may be longer than usual. Thank you for your patience."
};

export { SYSTEM_MAINTENANCE_NOTICE };
